import React from 'react';
import Logo from "../images/logo.png"
import "../css/loader.css";

const SuspenseLoader = () => {
    return (
        <div className="preloader">
            <img src={Logo} alt="logo" width={500}/>
            {/* <div className="loader"></div> */}
        </div>
    )
}

export default SuspenseLoader;